<script setup lang="ts">
/**
 * @description UI-kit typography component — text link
 * @category UI / Typography
 * @figma https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3360-100151
 */
import type { AppTextLinkProps } from '../types/interfaces'

import { useAppText } from '../composables/use-app-text.hook'

defineOptions({ name: 'AppTextLink' })

const props = withDefaults(defineProps<AppTextLinkProps>(), {
  name: 'body1',
  align: 'inherit',
  textDecoration: 'none',
  block: false,
  truncate: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  resolvedTag,
  classList,
  linkAttrs,
  handleClick,
} = useAppText({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="resolvedTag"
    :class="classList"
    v-bind="linkAttrs"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="../styles/_app-text.scss" />
